// extracted by mini-css-extract-plugin
export default {"text":"Message_text__aMVcH"};